import { VAutocomplete } from 'vuetify/lib';

export default {
  name: 'autocomplete',
  extends: VAutocomplete,
  props: {
    openOnEnter: { type: Boolean, default: true },
  },
  methods: {
    onEnterDown() {
      if (!this.openOnEnter) {
        this.hideMenu()
      }

      this.$emit('enter')
    },
    hideMenu() {
      this.isMenuActive = false;
    }
  }
}
